import React from 'react';
import { connect } from 'react-redux';
import { Autocomplete, TextField } from '@mui/material';

import './building-fields-edit.css';

const FIELDS = ['address', 'purpose', 'timezone', 'area', 'area_unit_id'];
const WIDTH = {
  area: '100px',
  area_unit_id: '250px',
  address: '350px',
};
const TYPES = {
  area: 'number',
};
const API_FIELDS = {
  area_unit_id: 'areaUnitId',
};

/**
 * Controlled component for editing building information fields
 */
const BuildingFieldsEdit = ({ building, changes, setChanges, units }) => (
  <div className="building-fields-edit" key={building.id}>
    {FIELDS.map((field) => {
      if (field === 'area_unit_id')
        return (
          <Autocomplete
            key={field}
            options={units}
            style={{ display: 'inline-flex', width: WIDTH[field] || undefined }}
            onChange={(_event, { id }) => setChanges({ [field]: id })}
            getOptionLabel={(unit) => unit.name_long}
            value={
              units.filter(
                (u) => u.id === (changes[field] || building[API_FIELDS[field] || field])
              )[0]
            }
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField label="Select" {...params} />}
          />
        );
      if (field === 'timezone')
        return (
          <Autocomplete
            key={field}
            options={Intl.supportedValuesOf('timeZone')}
            style={{ display: 'inline-flex', width: '250px' }}
            value={changes[field] || building[API_FIELDS[field] || field] || ''}
            onChange={(e, value) => setChanges({ [field]: value ?? e.target.value })}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField label="Select" {...params} />}
          />
        );
      return (
        <TextField
          className={`building-field ${field}`}
          type={TYPES[field] || 'text'}
          key={field}
          label={field}
          style={{ width: WIDTH[field] || undefined }}
          value={changes[field] || building[API_FIELDS[field] || field] || ''}
          onChange={({ target: { value } }) => setChanges({ [field]: value })}
        />
      );
    })}
  </div>
);

const mapStateToProps = (state) => {
  const {
    entities: {
      units: { all },
    },
  } = state;
  return {
    // We do not have an area measurement (no point types depend on it) for now, so a bit of hackyness
    units: all.filter((u) => u.unit_type === 'http://qudt.org/vocab/quantitykind/Area'),
  };
};
export default connect(mapStateToProps)(BuildingFieldsEdit);
